
export default "/assets/link-slash-micro.d914347c.svg"